<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { useValidation } from "@/composables/useValidation";
import {
  OrderEditStatusMap,
  OrderStatus,
  OrderStatusMap,
  type OrderStatusMapItem,
  OrderStatusTransitions,
} from "@/constants/order";
import OmniAutocomplete from "@/components/selects/OmniAutocomplete.vue";

const { t } = useI18n();
const { requiredValidator } = useValidation();

const status = defineModel<OrderStatus>({ default: OrderStatus.inProgress });

const props = withDefaults(
  defineProps<{
    statusFromApi?: OrderStatus;
    disabled?: boolean;
    readonly?: boolean;
  }>(),
  {
    statusFromApi: undefined,
    disabled: false,
    readonly: false,
  },
);

const statusOptions = computed<OrderStatusMapItem[]>(() => {
  if (!props.statusFromApi) {
    return OrderEditStatusMap;
  }

  const statusesToTransition = OrderStatusTransitions[props.statusFromApi];

  return OrderEditStatusMap.filter((item) => statusesToTransition.includes(item.id));
});

const selectedStatusName = computed<string>(() => {
  return OrderStatusMap.find((item) => item.id === status.value)?.name ?? "";
});
</script>

<template>
  <omni-autocomplete
    v-model="status"
    :clearable="false"
    :disabled="props.disabled"
    :readonly="props.readonly"
    :items="statusOptions"
    :label="t('general.status')"
    :rules="[requiredValidator]"
    data-qa="order-status-select"
    required
  >
    <template #selection>{{ selectedStatusName }}</template>
  </omni-autocomplete>
</template>
